module.exports = __webpack_public_path__ + "img/ao.2bfdbcc0.svg";